<div class="modal-header bg-white py-2 border-bottom-0">
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="modal-body d-flex flex-column justify-content-center" *ngIf="modalSubType" style="min-height: 300px;padding: 9px 64px 64px">
    <h2 class="modal-title text-center mb-0" style="color: #2F2B3DE5; font-size: 24px; padding-bottom: 8px;">
        {{ (isEditMode ? 'Modifier' : 'Ajouter') + ' une ' + (modalSubType.charAt(0).toUpperCase() + modalSubType.slice(1)) }}
    </h2>
    <p class="text-muted text-center text-secondaire p-0">Remplissez les informations nécessaires pour {{ isEditMode ? 'modifier' : 'ajouter' }} {{ modalSubType }}.</p>
    <form class="flex-grow-1" #itemForm="ngForm">
        <div class="form-group">
            <label class="text-dark" style="font-weight: 400; font-size: 15px;">
                {{ modalSubType === 'catégorie' ? 'Code' : modalSubType === 'unité' ? 'Label' : 'Nom' }} <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control"
                   placeholder="Entrez le {{ modalSubType === 'catégorie' ? 'code' : modalSubType === 'unité' ? 'label' : 'nom' }} de {{ modalSubType === 'catégorie' ? 'la catégorie' : modalSubType === 'unité' ? 'l\' unité' : 'la marque' }}"
                   [(ngModel)]="code" name="code" required >
            <div *ngIf="itemForm.controls['code']?.invalid && itemForm.controls['code']?.touched" class="text-danger">
                {{ modalSubType === 'catégorie' ? 'Le code est requis.' : modalSubType === 'unité' ? 'Le label est requis.' : 'Le nom est requis.' }}
            </div>
        </div>
        <div class="text-center mt-auto">
            <button type="button" class="btn btn-primary mr-2" (click)="save()" [disabled]="itemForm.invalid">Valider</button>
            <button type="button" class="btn" style="background:rgba(128, 131, 144, 0.16) " (click)="closeModal()">Annuler</button>
        </div>
    </form>
</div>
